<template>
  <div>
    <slot :sendForm="sendForm"></slot>

    <form
      :id="`course-${course.course_id}`"
      :name="`course-${course.course_id}`"
      :action="action"
      method="post"
      style="display: none;"
    >
      <input type="text" name="RutOtec" :value="course.institution_rut" />
      <input type="text" name="Token" :value="course.institution_token" />
      <input type="text" name="CodSence" :value="course.course_cod_sence" />
      <input type="text" name="CodigoCurso" :value="course.course_code" />
      <input
        type="text"
        name="LineaCapacitacion"
        :value="course.training_line"
      />
      <input type="text" name="RunAlumno" :value="user.rut" />
      <input type="text" name="IdSesionAlumno" :value="user.id" />
      <input
        v-if="!isLogin"
        type="text"
        name="IdSesionSence"
        :value="IdSesionSence"
      />
      <input type="text" name="UrlRetoma" :value="`${path}/success`" />
      <input type="text" name="UrlError" :value="`${path}/error`" />
      <input type="submit" value="Submit" />
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import localStorage from "@/services/localStorage.service";
export default {
  props: {
    course: {
      type: Object,
      required: true
    },
    isLogin: {
      type: Boolean,
      default: true
    },
    IdSesionSence: String
  },
  computed: {
    ...mapState(["user"]),
    path() {
      return this.isLogin
        ? `${process.env.address.api}sence/login`
        : `${process.env.address.api}sence/logout`;
    },
    action() {
      return this.isLogin
      //  ? "https://sistemas.sence.cl/rcetest/Registro/IniciarSesion"
      //  : "https://sistemas.sence.cl/rcetest/Registro/CerrarSesion";
       ? "https://sistemas.sence.cl/rce/Registro/IniciarSesion"
       : "https://sistemas.sence.cl/rce/Registro/CerrarSesion";
    }
  },
  methods: {
    sendForm() {
      if (!this.$route.path.includes("error")) {
        localStorage.setItem("nextRoute", this.$route.path);
      }
      const formName = `course-${this.course.course_id}`;
      // for (let i = 0; i < document.forms[formName].elements.length; i++) {
      //   const e = document.forms[formName].elements[i];
      //   console.log(e.value);
      // }
      // debugger;
      document.forms[formName].submit();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SENCE/Form.vue